"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.price = void 0;
exports.price = [
    {
        id: 1,
        name: '5k-10k',
        value: [5, 10],
        query: { price_min: 5000, price_max: 10000 },
    },
    {
        id: 2,
        name: '10k-20k',
        value: [10, 20],
        query: { price_min: 10000, price_max: 20000 },
    },
    {
        id: 3,
        name: '20k-30k',
        value: [20, 30],
        query: { price_min: 20000, price_max: 30000 },
    },
    {
        id: 4,
        name: '30k-40k',
        value: [30, 40],
        query: { price_min: 30000, price_max: 40000 },
    },
    {
        id: 5,
        name: '40k-50k',
        value: [40, 50],
        query: { price_min: 40000, price_max: 50000 },
    },
    {
        id: 6,
        name: 'above-50k',
        value: [50],
        query: { price_min: 50000 },
    },
];
